import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css"; // this is required by gallery

export default function BreadE() {
  const names = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  let images = [];
  for (const name of names) {
    images.push({
      original: `photos/breed-e/${name}.jpg`,
      thumbnail: `photos/breed-e/small${name}.jpg`
    })
  }

  return (
    <div>
      <div className="container">
        <div className="row center">
          <h2 className="header col s12 light">E vada</h2>
          <p className="headline light">Keturi patinėliai. 2022 metų gegužės 29 dieną.</p>
        </div>
        <div className="row center">
          <img src="photos/breed-e/pedigree.jpg" title="E Breed" alt="breed-e" width="100%" />
        </div>
        <div className="row center">
          <h2>Šuniukų galerija</h2>
        </div>
        <div className="row center">
          <ImageGallery items={images} slideInterval={2000} />
        </div>
      </div>
    </div>
  );

}
